import {
  ColorValues,
  Flex,
  IconBrandIconToday,
  Typography,
} from '@banhala/ui-kit';

export const TodayDeliveryOptionBadge = ({
  isSoldOut,
  orderDeadline,
}: {
  isSoldOut: boolean;
  orderDeadline: string | null;
}) => (
  <Flex.Row alignItems={'center'} gap={4}>
    <IconBrandIconToday color={ColorValues.lilac40} />
    {isSoldOut ? (
      <Typography type={'body4'} color={'content_disabled'}>
        품절
      </Typography>
    ) : (
      <Typography type={'body4'} color={'content_slate_primary'}>
        {orderDeadline ?? ''}
      </Typography>
    )}
  </Flex.Row>
);
